import script from "./Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Info.vue?vue&type=script&setup=true&lang=js"

import "./Info.vue?vue&type=style&index=0&id=61ef2a99&lang=css"
import "./Info.vue?vue&type=style&index=1&id=61ef2a99&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ef2a99"]])

export default __exports__